import React from "react";
import EmailPassword from "./../../components/EmailPassword";

const Recovery = () => {
  return <EmailPassword />;
};

export default Recovery;
